import React, { useContext, useMemo } from 'react';

import { ToolbarContext } from '../..';
import { Button } from '../../../../../../shared/components';
import Spin from '../../../../../../shared/components/spin';
import { useStopRecordingButtonContent } from '../../toolbar-buttons/base-stop-recording-button';
import styles from './styles.css';

export function WaitingCloudRecordingButton() {
    const { content } = useStopRecordingButtonContent('cloud');
    const { buttonSize } = useContext(ToolbarContext);
    const spinner = useMemo(() => {
        return <Spin size="md" color="white" progress />;
    }, []);

    return (
        <Button className={styles.stopButton} view="neutral" size={buttonSize} isDisabled={true} iconLeft={spinner}>
            {content}
        </Button>
    );
}
